import React from 'react';
import styled from 'styled-components';
import { type TrainingFormProps } from './types';
import { APPLICATION_TEXT } from '../../lang';
import { DocumentBox } from '../../../../../components';

const TRAINING_TEXT = APPLICATION_TEXT.TRAINING;
export const TrainingForm: React.FunctionComponent<TrainingFormProps> = (
  props: TrainingFormProps,
) => {
  const { training, trainingIndex } = props;
  const {
    from,
    to,
    country,
    organisationName,
    programmeName,
    supportingDocuments,
  } = training;
  const renderData = [
    {
      label: TRAINING_TEXT.FROM,
      value: from,
      isFullWidth: false,
    },
    {
      label: TRAINING_TEXT.TO,
      value: to,
      isFullWidth: false,
    },
    {
      label: TRAINING_TEXT.COUNTRY,
      value: country,
      isFullWidth: true,
    },
    {
      label: TRAINING_TEXT.ORGANIZATION_NAME,
      value: organisationName,
      isFullWidth: true,
    },
    {
      label: TRAINING_TEXT.PROGRAMME,
      value: programmeName,
      isFullWidth: true,
    },
  ];

  const hasFiles = supportingDocuments.length > 0;

  return (
    <Container>
      <h1>
        {TRAINING_TEXT.SUBTITLE}
        {' - '}
        {trainingIndex + 1}
      </h1>

      <div className="grid grid-cols-2 px-8 py-4 text-sm w-full">
        {renderData.map((item, index) => {
          return (
            <div key={index} className="py-2 border-b border-solid">
              <span className="text-[#224295]">{item.label}</span>:&nbsp;&nbsp;
              {item.value}
            </div>
          );
        })}
      </div>

      <div className="supporting-documents">
        <h3>{APPLICATION_TEXT.SUPPORTING_DOCUMENT}</h3>
        <div className="document-display">
          {hasFiles ? (
            supportingDocuments.map((file, index) => {
              return <DocumentBox key={index} file={file} />;
            })
          ) : (
            <div>
              <p>{APPLICATION_TEXT.NA}</p>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h1 {
    text-align: left !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    margin: 1rem !important;
  }

  .supporting-documents {
    padding: 0.5rem 0 0 2rem;

    .document-display {
      padding: 0.5rem 1rem;
    }

    h3 {
      font-style: italic;
      color: #8c8c8c;
    }
  }

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
